export class DataModel {
  id: any;
  nome: string;
  complementar: any;

  constructor(_nome: string = null, _id: any = null, _complementar: any = null) {
    this.nome = _nome;
    this.id = _id;
    this.complementar = _complementar;
  }
}
